"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceProvider = exports.InvoiceContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ApiInvoiceRepo_1 = require("../../../modules/invoice/infra/ApiInvoiceRepo");
const getById_1 = require("../../../modules/invoice/app/getById");
const update_1 = require("../../../modules/invoice/app/update");
exports.InvoiceContext = (0, react_1.createContext)(null);
const InvoiceProvider = ({ children, }) => {
    const invoiceRepo = (0, ApiInvoiceRepo_1.createApiInvoiceRepo)();
    const value = {
        getById: (id) => (0, getById_1.getById)(invoiceRepo, id),
        update: (invoice) => (0, update_1.update)(invoiceRepo, invoice),
    };
    return ((0, jsx_runtime_1.jsx)(exports.InvoiceContext.Provider, { value: value, children: children }));
};
exports.InvoiceProvider = InvoiceProvider;
